import {gql} from '@apollo/client';

export const MediaTaggingAllowance = gql`
    query MediaTaggingAllowance($institutionSetIds: [InstitutionSetId!]!) {
        mediaTagging {
            tagAllowance {
                list(institutionSetIds: $institutionSetIds) {
                    result {
                        childrenAllowance {
                            child {
                                id
                                profileImage {
                                    url
                                }
                                name {
                                    fullName
                                }
                            }
                            allowance
                        }
                    }
                }
            }
        }
    }
`;

export const Institutions = gql`
    query Institutions {
        institutions {
            institutionId
        }
    }
`;

export const InstitutionsBehaviors = gql`
    query InstitutionsBehaviors {
        institutions {
            behaviors {
                behaviorId
            }
        }
    }
`;

export const TagMedia = gql`
    mutation TagMedia($input: [MediaTagInput!]!) {
        mediaTagging {
            mediaTag {
                create(input: $input) {
                    childrenMedia {
                        children {
                            id
                        }
                    }
                }
            }
        }
    }
`;

export const MediaTagged = gql`
    query MediaTagged($videoIds: [VideoId!], $imageIds: [ImageId!]) {
        mediaTagging {
            mediaTagged {
                list(videoIds: $videoIds, imageIds: $imageIds) {
                    childrenMedia {
                        mediaId
                        children {
                            id
                        }
                    }
                }
            }
        }
    }
`;
